
export const brandName = 'BergaGonzález';

export const PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_SITE_URL;

export const INDEX_PAGES = true;

// Email encoded to prevent spam bots
// estudio@bergagonzalez.com
export const emailEncoded = '&#101;&#115;&#116;&#117;&#100;&#105;&#111;&#64;&#98;&#101;&#114;&#103;&#97;&#103;&#111;&#110;&#122;&#97;&#108;&#101;&#122;&#46;&#99;&#111;&#109;';

export const emailEstudioDecoded = 'estudio@bergagonzalez.com';

export const emailCVEncoded = '&#99;&#118;&#64;&#98;&#101;&#114;&#103;&#97;&#103;&#111;&#110;&#122;&#97;&#108;&#101;&#122;&#46;&#99;&#111;&#109;';

export const telfEncoded = '&#43;&#51;&#52;&#32;&#57;&#51;&#32;&#51;&#49;&#56;&#32;&#55;&#53;&#32;&#49;&#51;'; // +34 93 318 75 13

export const VIMEO_TOKEN = '0481d492d16efe99bf4f4d2b4a6ac4a4';

export const emailEstudioNotEncoded = 'estudio@bergagonzalez.com';

export const DATA_WEB_PUBLISHED_DATE = new Date('2025-09-15T00:00:00Z');